// extracted by mini-css-extract-plugin
module.exports = {"settings":"style__settings__pok2W","resetBtn":"style__resetBtn__E3z34"};